import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendedWaitingModuleComponent } from '@components/extendedWaitingModule/extendedWaitingModule.component';
import { CompleteAnimationComponent } from '@dialogs/createTaskRelatedDialogs/create-task/UI/steps/budget-generation/complete-animation/complete-animation.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedPipeModule } from '@app/shared/pipes/shared.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    CompleteAnimationComponent,
    MatIconModule,
    SharedPipeModule,
  ],
  declarations: [ExtendedWaitingModuleComponent],
  exports: [ExtendedWaitingModuleComponent],
})
export class ExtendedWaitingModuleModule {}
